import {Wallet, Coins, BarChart2, DollarSign, FileText} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { useHapticFeedback } from '../../hooks/useHapticFeedback';

interface QuickFiltersProps {
  activeFilter: string | null;
  onFilterChange: (category: string | null) => void;
}

export default function QuickFilters({ activeFilter, onFilterChange }: QuickFiltersProps) {
  const { t } = useTranslation();
  const { impactOccurred } = useHapticFeedback();

  const filters = [
    { id: 'all', label: t('HOME_SCREEN.QUICK_FILTERS.ALL'), icon: Wallet, category: null },
    { id: 'stablecoins', label: t('HOME_SCREEN.QUICK_FILTERS.STABLECOINS'), icon: DollarSign, category: 'Stablecoins' },
    { id: 'staking', label: t('HOME_SCREEN.QUICK_FILTERS.STAKING'), icon: Coins, category: 'Staking' },
    { id: 'lending', label: t('HOME_SCREEN.QUICK_FILTERS.LENDING'), icon: FileText, category: 'Lending' },
    { id: 'dexes', label: t('HOME_SCREEN.QUICK_FILTERS.DEXES'), icon: BarChart2, category: 'DEX' }
  ];

  const handleFilterClick = (category: string | null) => {
    impactOccurred('medium');
    onFilterChange(category);
  };

  return (
    <div className="flex gap-2.5 w-full overflow-x-auto scrollbar-hide py-1 pb-2 [-webkit-overflow-scrolling:touch]">
      {filters.map(({ id, label, icon: Icon, category }) => {
        const isActive = activeFilter === category;
        return (
          <button
            key={id}
            className={cn(
              'flex items-center gap-2 px-3.5 py-2.5',
              'bg-tg-secondary-bg rounded-2xl whitespace-nowrap',
              'select-none border border-black/5',
              'transition-all duration-200 cursor-pointer',
              'active:scale-[0.96]',
              isActive && 'bg-gradient-pink border-0 text-white shadow-[0_2px_8px_rgba(255,0,128,0.15)]',
              'max-[360px]:px-3 max-[360px]:py-2'
            )}
            onClick={() => handleFilterClick(category)}
          >
            <Icon 
              className={cn(
                'w-[18px] h-[18px] flex-shrink-0 transition-all duration-200 relative z-[2]',
                isActive ? 'text-white scale-110' : 'text-tg-hint'
              )} 
              size={20} 
              strokeWidth={1.5} 
            />
            <span className={cn(
              'text-[13px] font-medium leading-4 text-tg-hint',
              'transition-all duration-200 relative z-[2] tracking-wide',
              isActive && 'text-white',
              'max-[360px]:text-xs'
            )}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
} 